import { ILanguages } from './@types';

const CURRENT_LOCALE_LOCAL_STORE_KEY = 'locale';

const languages: ILanguages = {
  en: {
    id: 'en',
    label: 'EN',
    value: 'en',
  },
  es: {
    id: 'es',
    label: 'ES',
    value: 'es',
  },
  pt: {
    id: 'pt',
    label: 'PT',
    value: 'pt',
  },
};

const languagesArray = Object.values({ ...languages });

export { languages, languagesArray, CURRENT_LOCALE_LOCAL_STORE_KEY };
